export default "__VITE_ASSET__CaqN$91K__"